export enum DiscussedInTeam {
  YES = 'YES',
  NO = "NO"
}

export const discussedInTeamToLabel = {
  [DiscussedInTeam.YES]: 'Yes',
  [DiscussedInTeam.NO]: 'No'
}
